import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedAppKey: null,
};

const dashboardSelectedAppSlice = createSlice({
  name: 'dashboardSelectedApp',
  initialState,
  reducers: {
    selectApp: (state, action) => {
      state.selectedAppKey = action.payload;
    },
    clearSelectedApp: (state) => {
      state.selectedAppKey = null;
    },
  },
});

export const { selectApp, clearSelectedApp } = dashboardSelectedAppSlice.actions;
export default dashboardSelectedAppSlice.reducer;